// extracted by mini-css-extract-plugin
module.exports = {"tag-page":"TagPage_tag-page__wJqVM","tag-page__description":"TagPage_tag-page__description__26WO-"};